import React from 'react'
import {ReactComponent as Lin } from '../../../assets/svg/linobs.svg'
import {ReactComponent as Fb } from '../../../assets/svg/fbobs.svg'
const ObserverCard = ({setCurrentObs,handleOpen,imgPath,name,role,bio,face,lin,occupation,description}) => {
const handleCLicked= () =>{
  setCurrentObs({
    name: name,imgPath: imgPath,bio: bio,face: face,lin: lin,role: role,occupation:occupation,description: description
  })
  handleOpen();
}
  return (
    <div onClick={() => { handleCLicked() }} className='cursor-pointer h-[524px] w-[305px] grid rounded-xl overflow-hidden shadow-2xl'>
    <img 
        alt="some img" 
        className="h-[300px] w-[305px] object-cover" 
        src={`https://cdn.sanity.io/images/xazjl9sh/production/${imgPath.slice(6, -4) + '.' + imgPath.slice(-3)}`} 
    />
    <div className='p-4 grid gap-1'>
        <h1 className='text-xl text-[#006DC4]'>{name}</h1>
        <p className='text-md text-[#484848]'>{description}</p>
        <div className='flex justify-center space-x-4'>
            <a target='_blank' rel="noreferrer" href={face}><Fb /></a>
            <a target='_blank' rel="noreferrer" href={lin}><Lin /></a>
        </div>
    </div>
</div>

  )
}

export default ObserverCard